export const PackageIcon = () => (
  <svg
    width={21}
    height={19}
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1635_4740)">
      <path
        d="M2.86125 5.51098L10.5 9.5089L18.1387 5.51098M10.5 17.481V9.50098M18.375 12.6676V6.33431C18.3747 6.05666 18.2937 5.78395 18.1401 5.54357C17.9865 5.30318 17.7658 5.10356 17.5 4.96473L11.375 1.79806C11.109 1.6591 10.8072 1.58594 10.5 1.58594C10.1928 1.58594 9.89103 1.6591 9.625 1.79806L3.5 4.96473C3.23423 5.10356 3.01348 5.30318 2.8599 5.54357C2.70632 5.78395 2.62531 6.05666 2.625 6.33431V12.6676C2.62531 12.9453 2.70632 13.218 2.8599 13.4584C3.01348 13.6988 3.23423 13.8984 3.5 14.0372L9.625 17.2039C9.89103 17.3429 10.1928 17.416 10.5 17.416C10.8072 17.416 11.109 17.3429 11.375 17.2039L17.5 14.0372C17.7658 13.8984 17.9865 13.6988 18.1401 13.4584C18.2937 13.218 18.3747 12.9453 18.375 12.6676Z"
        stroke="#FA7F05"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1635_4740">
        <rect width={21} height={19} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AlarmIcon = () => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9998 20.1648C9.85397 20.1648 8.78071 19.9471 7.78001 19.5117C6.77932 19.0763 5.90849 18.4881 5.16751 17.7471C4.42654 17.0062 3.83835 16.1353 3.40293 15.1346C2.96751 14.1339 2.7498 13.0607 2.7498 11.9148C2.7498 10.769 2.96751 9.69575 3.40293 8.69505C3.83835 7.69436 4.42654 6.82352 5.16751 6.08255C5.90849 5.34158 6.77932 4.75339 7.78001 4.31797C8.78071 3.88255 9.85397 3.66484 10.9998 3.66484C12.1456 3.66484 13.2189 3.88255 14.2196 4.31797C15.2203 4.75339 16.0911 5.34158 16.8321 6.08255C17.5731 6.82352 18.1613 7.69436 18.5967 8.69505C19.0321 9.69575 19.2498 10.769 19.2498 11.9148C19.2498 13.0607 19.0321 14.1339 18.5967 15.1346C18.1613 16.1353 17.5731 17.0062 16.8321 17.7471C16.0911 18.4881 15.2203 19.0763 14.2196 19.5117C13.2189 19.9471 12.1456 20.1648 10.9998 20.1648ZM13.5665 15.7648L14.8498 14.4815L11.9165 11.5482V7.33151H10.0831V12.2815L13.5665 15.7648ZM5.13314 2.15234L6.41647 3.43568L2.52064 7.33151L1.2373 6.04818L5.13314 2.15234ZM16.8665 2.15234L20.7623 6.04818L19.479 7.33151L15.5831 3.43568L16.8665 2.15234ZM10.9998 18.3315C12.7873 18.3315 14.3036 17.7089 15.5488 16.4638C16.7939 15.2187 17.4165 13.7023 17.4165 11.9148C17.4165 10.1273 16.7939 8.61102 15.5488 7.36589C14.3036 6.12075 12.7873 5.49818 10.9998 5.49818C9.21231 5.49818 7.69599 6.12075 6.45085 7.36589C5.20571 8.61102 4.58314 10.1273 4.58314 11.9148C4.58314 13.7023 5.20571 15.2187 6.45085 16.4638C7.69599 17.7089 9.21231 18.3315 10.9998 18.3315Z"
      fill="#FA7F05"
    />
  </svg>
);

export const LeavePointIcon = () => (
    <svg width={23} height={23} viewBox="0 0 23 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.4998 3.09375C9.51506 3.09375 7.90609 3.72335 7.90609 4.5C7.90609 5.27665 9.51506 5.90625 11.4998 5.90625C13.4846 5.90625 15.0936 5.27665 15.0936 4.5C15.0936 3.72335 13.4846 3.09375 11.4998 3.09375Z" fill="#FA7F05" />
        <path fillRule="evenodd" clipRule="evenodd" d="M11.4998 0.46875C11.8968 0.46875 12.2186 0.59467 12.2186 0.75V1.23063C16.2764 1.36542 19.5104 2.63093 19.8549 4.21875H21.0832C21.4801 4.21875 21.8019 4.34467 21.8019 4.5C21.8019 4.65533 21.4801 4.78125 21.0832 4.78125H19.8549C19.5104 6.36907 16.2764 7.63458 12.2186 7.76937V8.25C12.2186 8.40533 11.8968 8.53125 11.4998 8.53125C11.1029 8.53125 10.7811 8.40533 10.7811 8.25V7.76937C6.72332 7.63458 3.48926 6.36907 3.14479 4.78125H1.9165C1.51955 4.78125 1.19775 4.65533 1.19775 4.5C1.19775 4.34467 1.51955 4.21875 1.9165 4.21875H3.14479C3.48926 2.63093 6.72332 1.36542 10.7811 1.23063V0.75C10.7811 0.59467 11.1029 0.46875 11.4998 0.46875ZM4.55192 4.5C4.55192 6.00152 7.66261 7.21875 11.4998 7.21875C15.3371 7.21875 18.4478 6.00152 18.4478 4.5C18.4478 2.99848 15.3371 1.78125 11.4998 1.78125C7.66261 1.78125 4.55192 2.99848 4.55192 4.5Z" fill="#FA7F05" />
    </svg>
);

export const DeliverPointIcon = () => (
<svg width={22} height={22} viewBox="0 0 22 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd" d="M6.64602 4.16536C6.64602 3.0723 8.59545 2.1862 11.0002 2.1862C13.4049 2.1862 15.3544 3.0723 15.3544 4.16536C15.3544 5.25843 13.4049 6.14453 11.0002 6.14453C8.59545 6.14453 6.64602 5.25843 6.64602 4.16536ZM11.0002 2.8112C9.35484 2.8112 8.02102 3.41748 8.02102 4.16536C8.02102 4.91325 9.35484 5.51953 11.0002 5.51953C12.6455 5.51953 13.9794 4.91325 13.9794 4.16536C13.9794 3.41748 12.6455 2.8112 11.0002 2.8112Z" fill="#FA7F05" />
  <path fillRule="evenodd" clipRule="evenodd" d="M3.23085 3.68905C3.55565 1.89797 6.84846 0.519531 10.8022 0.519531H11.1982C15.1519 0.519531 18.4447 1.89797 18.7695 3.68905C18.944 4.6512 18.2902 5.60657 16.9457 6.35394L12.5521 8.79635C11.75 9.24222 10.2504 9.24223 9.44829 8.79635L5.05465 6.35394C3.71022 5.60657 3.05637 4.6512 3.23085 3.68905ZM10.8022 1.14453C7.56405 1.14453 4.86722 2.27348 4.6012 3.7404C4.45599 4.54116 5.00017 5.3363 6.11911 5.95831L10.5127 8.40072C10.7647 8.54077 11.2357 8.54077 11.4876 8.40072L15.8813 5.95831C17.0002 5.33629 17.5444 4.54116 17.3992 3.7404C17.1332 2.27348 14.4363 1.14453 11.1982 1.14453H10.8022Z" fill="#FA7F05" />
</svg>
);

export const CalendarIcon = () => (
  <svg
    width={26}
    height={23}
    viewBox="0 0 26 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1635_4761)">
      <path
        d="M17.3333 1.91797V5.7513M8.66667 1.91797V5.7513M3.25 9.58464H22.75M5.41667 3.83464H20.5833C21.78 3.83464 22.75 4.69276 22.75 5.7513V19.168C22.75 20.2265 21.78 21.0846 20.5833 21.0846H5.41667C4.22005 21.0846 3.25 20.2265 3.25 19.168V5.7513C3.25 4.69276 4.22005 3.83464 5.41667 3.83464Z"
        stroke="#FA7F05"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1635_4761">
        <rect width={26} height={23} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowIcon = ({ className = '', style = {} }) => (
  <svg 
    viewBox="0 0 400 100" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    {/* Arrow line */}
    <line 
      x1="20" 
      y1="50" 
      x2="360" 
      y2="50" 
      stroke="white" 
      strokeWidth="2" 
      strokeLinecap="round"
    />
    
    {/* Arrow head */}
    <polyline 
      points="340,35 360,50 340,65" 
      fill="none" 
      stroke="white" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);